export const ROUTE_CONSTANT = {
  ROOT_HOME: "/",
  HOME: "/app/assessment/",
  QUIZ: "/app/assessment/",
  QUIZ_LOCALE: "/app/:locale/assessment/",
  QUIZ_B: "/app/assessment-b/",
  QUIZ_B_LOCALE: "/app/:locale/assessment-b/",
  SIGNOUT: "/app/account/sign-out/",
  LOGIN: "/app/account/login/",
  LOGIN_LOCALE: "/app/:locale/account/login/",
  SIGNUP: "/app/account/signup/",
  SIGNUP_LOCALE: "/app/:locale/account/signup/",
  FORGOT_PASSWORD: "/app/account/forgot-password/",
  FORGOT_PASSWORD_LOCALE: "/app/:locale/account/forgot-password/",
  RESET_PASSWORD: "/app/account/reset-password/",
  RESET_PASSWORD_LOCALE: "/app/:locale/account/reset-password/",
  PAYMENT_PLAN: "/app/payment/plan/",
  PAYMENT_PLAN_LOCALE: "/app/:locale/payment/plan/",
  CHECKOUT: "/app/payment/checkout/",
  CHECKOUT_LOCALE: "/app/:locale/payment/checkout/",
  CHECKOUT_B: "/app/payment/checkout/",
  CHECKOUT_B_LOCALE: "/app/:locale/payment/checkout/",
  CHECKOUT_C: "/app/payment/checkout-c/",
  CHECKOUT_C_LOCALE: "/app/:locale/payment/checkout-c/",
  CONFIRMATION: "/app/payment/confirmation/",
  CONFIRMATION_LOCALE: "/app/:locale/payment/confirmation/",
  SETTINGS: "/app/dashboard/settings/",
  SETTINGS_LOCALE: "/app/:locale/dashboard/settings/",
  FRIENDS: "/app/dashboard/friends/",
  PROFILE: "/app/dashboard/profile/",
  DASHBOARD: "/app/dashboard/",
  DASHBOARD_LOCALE: "/app/:locale/dashboard/",
  DASHBOARD_B: "/app/dashboard-b/",
  DASHBOARD_B_LOCALE: "/app/:locale/dashboard-b/",
  PROCCESOR: "/app/dashboard/processor/",
  PERSONALITY_REPORT: "/app/dashboard/report/personality/",
  PERSONALITY_REPORT_LOCALE: "/app/:locale/dashboard/report/personality/",
  CAREER_PRE_CONTENT: "/app/dashboard/report/career-pre-content/",
  CAREER_PRE_CONTENT_LOCALE:
    "/app/:locale/dashboard/report/career-pre-content/",
  CAREER_PRE_CONTENT_UNAUTH: "app/account/career-pre-content/",
  CAREER_REPORT: "/app/dashboard/report/career/",
  CAREER_REPORT_LOCALE: "/app/:locale/dashboard/report/career/",
  CAREER_RESULT_UNAUTH: "/app/account/career-result-view/",
  REPORT_UNAUTH: "/app/account/view-report/",
  LOGIN_AS_ADMIN: "/app/admin/login-as-admin/",
  ADMIN_LOGIN: "/app/admin/login/",
  ADMIN_SEARCH: "/app/admin/search/",
  BIG_FIVE_REPORT: "/app/dashboard/report/big-five/",
  BIG_FIVE_REPORT_LOCALE: "/app/:locale/dashboard/report/big-five/",
  BIG_FIVE_FACETS_REPORT: "/app/dashboard/report/big-five-facets/",
  BIG_FIVE_FACETS_REPORT_LOCALE:
    "/app/:locale/dashboard/report/big-five-facets/",
  ENNEAGRAM_REPORT: "/app/dashboard/report/enneagram/",
  ENNEAGRAM_REPORT_LOCALE: "/app/:locale/dashboard/report/enneagram/",
  LIKEABILITY_REPORT: "/app/dashboard/report/likeability/",
  LIKEABILITY_REPORT_LOCALE: "/app/:locale/dashboard/report/likeability/",
  PERSONALITY_DISORDER_REPORT: "/app/dashboard/report/personality-disorder/",
  PERSONALITY_DISORDER_REPORT_LOCALE:
    "/app/:locale/dashboard/report/personality-disorder/",
  DISC_PERSONALITY_REPORT: "/app/dashboard/report/disc/",
  DISC_PERSONALITY_REPORT_LOCALE: "/app/:locale/dashboard/report/disc/",
  ADHD_REPORT: "/app/dashboard/report/adhd/",
  ADHD_REPORT_LOCALE: "/app/:locale/dashboard/report/adhd/",
  CAREER_PREFERENCE_REPORT: "/app/dashboard/report/career-preference/",
  CAREER_PREFERENCE_REPORT_LOCALE:
    "/app/:locale/dashboard/report/career-preference/",
  CAREER_PREFERENCE_REPORT_V2: "/app/dashboard/report/career-preference-b/",
  CAREER_PREFERENCE_REPORT_V2_LOCALE:
    "/app/:locale/dashboard/report/career-preference-b/",
  EMOTIONAL_INTELLIGENCE_REPORT:
    "/app/dashboard/report/emotional-intelligence/",
  EMOTIONAL_INTELLIGENCE_REPORT_LOCALE:
    "/app/:locale/dashboard/report/emotional-intelligence/",
  DIFFICULT_PERSON_REPORT: "/app/dashboard/report/difficult-person/",
  DIFFICULT_PERSON_REPORT_LOCALE:
    "/app/:locale/dashboard/report/difficult-person/",
  AUTISM_SPECTRUM_REPORT: "/app/dashboard/report/autism-spectrum/",
  AUTISM_SPECTRUM_REPORT_LOCALE:
    "/app/:locale/dashboard/report/autism-spectrum/",
  HIGHLY_SENSITIVE_PERSON_REPORT:
    "/app/dashboard/report/highly-sensitive-person",
  HIGHLY_SENSITIVE_PERSON_REPORT_LOCALE:
    "/app/:locale/dashboard/report/highly-sensitive-person",
  ATTACHMENT_STYLE_REPORT: "/app/dashboard/report/attachment-style",
  ATTACHMENT_STYLE_REPORT_LOCALE:
    "/app/:locale/dashboard/report/attachment-style",
  DYSLEXIA_SCREENING_CHILDREN_REPORT:
    "/app/dashboard/report/dyslexia-screening-children",
  DYSLEXIA_SCREENING_CHILDREN_REPORT_LOCALE:
    "/app/:locale/dashboard/report/dyslexia-screening-children",
  DYSLEXIA_SCREENING_ADULT_REPORT:
    "/app/dashboard/report/dyslexia-screening-adult",
  DYSLEXIA_SCREENING_ADULT_REPORT_LOCALE:
    "/app/:locale/dashboard/report/dyslexia-screening-adult",
  LOVE_STYLE_REPORT: "/app/dashboard/report/love-style",
  LOVE_STYLE_REPORT_LOCALE: "/app/:locale/dashboard/report/love-style",
  NARCISSISTIC_PERSONALITY_DISORDER_REPORT:
    "/app/dashboard/report/narcissistic-personality-disorder",
  NARCISSISTIC_PERSONALITY_DISORDER_REPORT_LOCALE:
    "/app/:locale/dashboard/report/narcissistic-personality-disorder",
  ANTISOCIAL_PERSONALITY_DISORDER_REPORT:
    "/app/dashboard/report/antisocial-personality-disorder",
  ANTISOCIAL_PERSONALITY_DISORDER_REPORT_LOCALE:
    "/app/:locale/dashboard/report/antisocial-personality-disorder",
  CAREER_PREFERENCE_PRE_CONTENT:
    "/app/dashboard/report/career-preference-pre-content/",
  CAREER_PREFERENCE_PRE_CONTENT_LOCALE:
    "/app/:locale/dashboard/report/career-preference-pre-content/",
  FOUR_TEMPERAMENT_PERSONALITY_REPORT:
    "/app/dashboard/report/four-temperament-personality-report/",
  FOUR_TEMPERAMENT_PERSONALITY_REPORT_LOCALE:
    "/app/:locale/dashboard/report/four-temperament-personality-report/",
  ROMANTIC_PERSONALITY_REPORT:
    "/app/dashboard/report/romantic-personality-report/",
  ROMANTIC_PERSONALITY_REPORT_LOCALE:
    "/app/:locale/dashboard/report/romantic-personality-report/",
  ROMANTIC_COMPATIBILITY_REPORT:
    "/app/dashboard/report/romantic-compatibility-report/",
  ROMANTIC_COMPATIBILITY_REPORT_LOCALE:
    "/app/:locale/dashboard/report/romantic-compatibility-report/",
  COLOR_BLIND_REPORT: "/app/dashboard/report/color-blind-report/",
  COLOR_BLIND_REPORT_LOCALE:
    "/app/:locale/dashboard/report/color-blind-report/",
  DEPRESSION_REPORT: "/app/dashboard/report/depression-report/",
  DEPRESSION_REPORT_LOCALE: "/app/:locale/dashboard/report/depression-report/",
  BIPOLAR_DISORDER_REPORT: "/app/dashboard/report/bipolar-disorder-report/",
  BIPOLAR_DISORDER_REPORT_LOCALE:
    "/app/:locale/dashboard/report/bipolar-disorder-report/",
  NOT_FOUND: "/not-found/",
  NOT_FOUND_LOCALE: "/app/:locale/not-found",
};
